const buttonPermit = (app, userInfo) => {
  app.directive("hasPermit", {
    mounted(el, binding) {
      if (!permsJudge(binding.value)) {
        el.parentNode.removeChild(el);
      }
      function permsJudge(value) {
        localStorage.setItem("useInfo", JSON.stringify(userInfo.userInfo));
        let perms = userInfo?.userInfo?.roleName.split(",");
        for (let item of perms) {
          if (item == value) {
            return true;
          }
        }
        return false;
      }
    },
  });
};

export default buttonPermit;
